import { useState } from 'react';
import dayjs from 'dayjs';
import { TextField } from '@mui/material';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers';

export default function DateRangePicker({sendDateRangeDataFromChild, dateStartInput, dateEndInput, fromDate, toDate, name}) {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);

    const handleStartDateChange = (newStartDate) => {
        setStartDate(newStartDate);
        if (endDate && endDate < newStartDate) {
            setEndDate(null);
        }
        sendDateRangeDataFromChild({"start": newStartDate, "end": endDate, "id": name});
    };
    const handleEndDateChange = (newEndDate) => {
        setEndDate(newEndDate);
        sendDateRangeDataFromChild({"start": startDate, "end": newEndDate, "id": name});
    };

    return (
        <LocalizationProvider dateAdapter={AdapterDayjs}>
            <div className='flex items-center space-x-4'>
                <DatePicker
                    value={startDate || dayjs(dateStartInput, 'DD/MM/YYYY')}
                    onChange={handleStartDateChange}
                    renderInput={(params) => <TextField className='focus:outline-none border-none' {...params} 
                    fullWidth />}
                    minDate={fromDate ? dayjs(fromDate) : null}
                    sx={{"& .MuiOutlinedInput-root": { "&:hover > fieldset": { border: '0px solid #F1F1F1'}} }} 
                    className='bg-background-normal focus:outline-none p-4 rounded-lg border border-none'
                    format="DD-MM-YYYY"
                />
                <div> - </div>
                <DatePicker
                    value={endDate || dayjs(dateEndInput, 'DD/MM/YYYY')}
                    onChange={handleEndDateChange}
                    disabled={(!dateStartInput)}
                    renderInput={(params) => <TextField {...params} fullWidth />}
                    minDate={startDate}
                    maxDate={toDate ? dayjs(toDate) : null}
                    sx={{"& .MuiOutlinedInput-root": { "&:hover > fieldset": { border: '0px solid #F1F1F1'}} }} className='bg-background-normal focus:outline-none p-4 rounded-lg border border-none'
                    format="DD-MM-YYYY"
                />
            </div>
        </LocalizationProvider>
    );
}
